import type {EffectCallback} from 'react';
import { useEffect} from 'react'
import {EMPTY_ARRAY} from '../helpers/constants'

/**
 * Runs once when the component is mounted.
 */
export function useMountEffect(effect: EffectCallback) {
    // useDebugValue(effect)
    return useEffect(effect, EMPTY_ARRAY)
}
